import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a715386")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("button", {
    type: _ctx.type,
    class: ["generic-button flex flex--valign-c flex--halign-c flex--gap-20", { primary: !_ctx.secondary && !_ctx.simple, secondary: _ctx.secondary, circular: _ctx.circular, simple: _ctx.simple, danger: _ctx.danger, small: _ctx.small, 'omit-icon-when-sm': _ctx.omitIconWhenSM }],
    disabled: _ctx.disabled,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.identifier)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "icon",
          identifier: _ctx.identifier,
          searching: _ctx.searching
        }, null, 8, ["identifier", "searching"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "generic-fade",
      mode: "out-in"
    }, {
      default: _withId(() => [
        (_openBlock(), _createBlock("span", {
          key: _ctx.title,
          class: ["text", {
                    'text--primary-b text--less-gap': _ctx.simple,
                    'text--color-white text--shadow': !_ctx.simple,
                    'text--uppercase': _ctx.uppercase,
                    ' text--size-22 text--semi-bold': !_ctx.small,
                    ' text--size-20 text--semi-bold': _ctx.small,
                }]
        }, _toDisplayString(_ctx.title), 3))
      ]),
      _: 1
    })
  ], 10, ["type", "disabled"]))
})